import { Controller } from 'stimulus'

// Checkbox "Combo" do cadastro de produto (espelho do "Kit promocional"): revela o botao
// "Configurar Combo" e, desmarcado, desfaz a composicao ao salvar.
//
// - composicao ja salva: desmarcar grava `_destroy = 1` no hidden do modal (allow_destroy) e avisa;
// - composicao ainda nao salva: desmarcar desabilita os inputs do modal, para nada ser enviado.
//
// O modal fica fora deste elemento (o Semantic UI o destaca para o fim do <body>), por isso e
// localizado pelo `data-attr`.
export default class extends Controller {
  static targets = ['input', 'button', 'warning']

  connect() {
    this.sync()
  }

  toggle() {
    this.sync()
  }

  sync() {
    const checked = this.inputTarget.checked
    const persisted = this.data.get('persisted') === 'true'

    if (this.hasButtonTarget) this.buttonTarget.hidden = !checked
    if (this.hasWarningTarget) this.warningTarget.hidden = !(persisted && !checked)

    const modal = document.querySelector('[data-attr="combo-config-modal"]')
    if (!modal) return

    const destroy = modal.querySelector('[data-attr="combo-remove"]')

    if (destroy) {
      destroy.value = checked ? '0' : '1'
      return
    }

    modal.querySelectorAll('input, select, textarea').forEach(field => {
      field.disabled = !checked
    })
  }
}
